<!--
 * @Author: yindengli
 * @Date: 2023-06-26 11:04:28
 * @LastEditTime: 2023-07-03 13:53:58
 * @LastEditors: yindengli
 * @Description: 
 * @FilePath: \openseeyon-index-front\src\components\FeedBack.vue
-->
<template>
    <div v-if="isShow" class="feedback" @mouseover="isHover = true" @mouseleave="isHover = false" @click="openFormtalk">
        <!-- 问题反馈按钮组件 -->
        <a-icon class="icon-font" type="form" :style="{color: isHover ? '#007AFF' : '' }" />
        <a-button title="问题反馈" :class="{ hoverColor: isHover }">问题反馈</a-button>
    </div>
</template>
<script>
import { getCookie } from "@/utils/common";

export default {
    name: "feedback-cmp",
    data() {
        return {
            isHover: false
        }
    },
    components: {
    },
    computed: {
        isShow(){
            const hidePages = ['officePlugin']
            return !hidePages.includes(this.$route.name)
        }
    },
    methods: {
        openFormtalk() {
            let cookie = getCookie('loginKey');
            if (!cookie) {
                // this.$warning({ content: '未登录，无法使用问题反馈功能，请先登录！'})
                this.$confirm({
                    title: '无法使用问题反馈',
                    content: '未登录，无法使用问题反馈功能，请先登录',
                    okText: '去登录',
                    cancelText: '取消',
                    onOk: ()=> {
                        // this.$router.push({name: 'login', query: { fromType: 'send' }})
                        this.$toLogin();
                    }
                })
                return;
            }
            // console.log('cookie--->', cookie)
            // window.open("https://pro.formtalk.net/pub.do?f=5519102C16ABEF31367C86AA9E9302FC237CCBE9A79969CC5697058C98477B32");
            this.$router.push({name: 'sendQuestion'})
        }
    }
}
</script>
<style scoped>
.feedback {
    text-align: center;
    background: #fff;
    padding: 5px;
    cursor: pointer;
    /* z-index: 1000; */
    width: 80px;
    height: 80px;
    border-radius: 52px;
    box-shadow: 0px 2px 24px 0px rgba(0,0,0,0.10); 
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    padding: 20px 0;
    color: #666666;
    margin-top: 20px;
}
.feedback .anticon {
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.feedback .ant-btn {
    display: block;
    padding: 0;
    height: 14px;
    font-size: 12px;
    border: 0;
    background: transparent;
    color: #333;
    box-shadow: none;
    margin-top: 4px;
}
.icon-font {
  font-size: 22px;
}
.feedback .ant-btn.hoverColor {
    color: #007AFF;
}
@media screen and (max-width: 824px) {
    .feedback{
        display: none;
    }
}
</style>